export default __webpack_public_path__ + "static/media/Q2_2_resized.1eada99c.jpg";